const getAssignedTo = (agents, teams, conversation) => {
  const assignedAgents = agents.filter((a) =>
    conversation.assigned_agent_ids.includes(a.id)
  );
  const assignedTeams = teams.filter((t) =>
    conversation.assigned_team_ids.includes(t.id)
  );

  const getAssignmentDisplay = () => {
    const combinedAssignments = [...assignedAgents, ...assignedTeams];

    if (combinedAssignments.length === 0) {
      return 'Unassigned';
    }

    const getName = () => {
      if (assignedAgents.length > 0) {
        return assignedAgents[0].full_name;
      }
      if (assignedTeams.length > 0) {
        return assignedTeams[0].name;
      }
      return null;
    };

    const plusMoreText = `${
      combinedAssignments.length > 1
        ? ` + ${combinedAssignments.length - 1} more`
        : ''
    }`;

    return `${getName()}${plusMoreText}`;
  };

  return getAssignmentDisplay();
};

export default getAssignedTo;
